import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../login/login.service';
import { AddDocService } from './add-doc.service';
import { SatDescargaService } from './sat-descarga.service';
import { ListaNegraService } from './lista-negra.service';
import { NotificationService } from '../../notifications/notification.service';

import * as JSZip from 'jszip';
import { PeriodoEjercicioService } from '../../control/periodo.service';



@Component({
  selector: 'app-add-doc',
  templateUrl: './add-doc.component.html',
  styleUrls: ['./add-doc.component.css'],
  providers: [AddDocService, SatDescargaService, ListaNegraService, NotificationService],
  preserveWhitespaces: true
})
export class AddDocComponent implements OnInit {

    info_cfdi: string = `Para cargar tus CFDI de forma manual debes seguir estos pasos:

1. Ingresa al portal de descarga masiva del SAT con tu e.firma.
2. Descarga los CFDI del mes, día por día (esto es necesario para garantizar que no excedas el límite de 500 CFDI por descarga).
3. Una vez descargados, tendrás varios archivos .ZIP.
4. Usa el botón "Carga manual de CFDI" para subir esos archivos .ZIP directamente al sistema.

De esta forma podrás tener todos tus CFDI cargados correctamente.`;
  public estatus_solicitud = 'p';
  public totalPages = 0;
  public page = 0;
  public itemsPerPage = 10;
  public rfc: String;
  public busqueda_cfdi: any = {};
  public totalItems: number;
  public rotate: any;
  public cfdis: any[] = [];
  public solicitudes: any[] = [];
  public consulta_lista_negra: any = { campos: [], lista: [] };
  public cargado: boolean;
  public todoSeleccionado: boolean;
  public nuevaSolicitud: Solicitud = new Solicitud();
  elemento: any = { nombre: '', contenido: '' };
  public campos: any = [{ nombre: 'uuid', checked: true },
  { nombre: 'serie', checked: true },
  { nombre: 'folio', checked: false },
  { nombre: 'tipo', checked: true },
  { nombre: 'tipo_cfdi', checked: true },
  { nombre: 'fecha_emision', checked: true },
  { nombre: 'rfc_emisor', checked: true },
  { nombre: 'emisor', checked: false },
  { nombre: 'rfc_receptor', checked: true },
  { nombre: 'receptor', checked: false }];
  //Lista de meses
  public meses: any[] = [
    { id: 1, nombre: 'Enero' },
    { id: 2, nombre: 'Febrero' },
    { id: 3, nombre: 'Marzo' },
    { id: 4, nombre: 'Abril' },
    { id: 5, nombre: 'Mayo' },
    { id: 6, nombre: 'Junio' },
    { id: 7, nombre: 'Julio' },
    { id: 8, nombre: 'Agosto' },
    { id: 9, nombre: 'Septiembre' },
    { id: 10, nombre: 'Octubre' },
    { id: 11, nombre: 'Noviembre' },
    { id: 12, nombre: 'Diciembre' }];

    public anos: any[] = [];
  constructor(private satDescargaService: SatDescargaService, private notificationService: NotificationService,
    private service: AddDocService, private loginService: LoginService, private listaNegraService: ListaNegraService, private periodoEjercicioService: PeriodoEjercicioService) { }


 mostrarInfo(texto: string) {
  Swal.fire({
    icon: 'info',
    title: 'TNK Ledger',
    html: texto.replace(/\n/g, '<br>')  // convierte saltos de línea en HTML
  });
}


  ngOnInit(): void {
    this.cargarAnos();
    const fechaActual = new Date();
    const fechaActualStr = fechaActual.toISOString().slice(0, 10);
    this.nuevaSolicitud.fecha_ini = fechaActualStr;
    this.nuevaSolicitud.fecha_fin = fechaActualStr;
    this.rfc = localStorage.getItem('rfc') + '';
    this.todoSeleccionado = false;
    this.busqueda_cfdi.criteriaSearch = {};
    this.busqueda_cfdi.itemsPerPage = 10;
    this.busqueda_cfdi.pageNumber = 0;
    this.mostrarMensajeCarga();
    this.catalogo();
  }
  async cargarDocumentos(files: FileList) {
  if (!files || files.length === 0) {
    return;
  }

  const maxSize = 200 * 1024 * 1024; // 200 MB
  const extensionesPermitidas = ['zip', 'xml'];

  // Caso 1: Si es un ZIP único, se manda directo
  if (files.length === 1 && files.item(0)?.name.toLowerCase().endsWith('.zip')) {
    const fileToUpload = files.item(0)!;

    if (fileToUpload.size > maxSize) {
      Swal.fire({
        icon: 'error',
        title: 'Tamaño excedido',
        text: 'El archivo ZIP supera el límite permitido de 200 MB.'
      });
      return;
    }

    this.subirArchivo(fileToUpload);
    return;
  }

  // Caso 2: Si son varios XMLs, los comprimimos
  const zip = new JSZip();
  let contieneSoloXml = true;
  let totalSize = 0; // acumulador del tamaño de todos los archivos

  for (let i = 0; i < files.length; i++) {
    const file = files.item(i);
    if (!file) continue;

    const extension = file.name.split('.').pop()?.toLowerCase();
    if (extension !== 'xml') {
      contieneSoloXml = false;
      break;
    }

    totalSize += file.size;
    if (totalSize > maxSize) {
      Swal.fire({
        icon: 'error',
        title: 'Tamaño excedido',
        text: 'La suma de los archivos XML supera el límite de 200 MB.'
      });
      return;
    }

    // Usamos FileReader para compatibilidad
    const content: ArrayBuffer = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });

    zip.file(file.name, content);
  }

  if (!contieneSoloXml) {
    Swal.fire({
      icon: 'error',
      title: 'Archivo no permitido',
      text: 'Si subes varios archivos, todos deben ser XML.'
    });
    return;
  }

  // Generar ZIP en memoria
  const blobZip = await zip.generateAsync({ type: 'blob' });

  if (blobZip.size > maxSize) {
    Swal.fire({
      icon: 'error',
      title: 'Tamaño excedido',
      text: 'El ZIP generado supera el límite permitido de 200 MB.'
    });
    return;
  }

  // Creamos un File para enviarlo como ZIP
  const zipFile = new File([blobZip], 'comprimido_cfdis.zip', { type: 'application/zip' });
  this.subirArchivo(zipFile);
}

private subirArchivo(file: File) {
  this.service.postDocsUser(file, this.loginService.empresa, this.loginService.usuario.id)
    .subscribe({
      next: (response) => {
        Swal.fire({
          icon: 'success',
          title: 'Subida exitosa',
          text: response.mensaje
        });
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al subir',
          text: err.error.mensaje
        });
        console.error(err);
      }
    });
}

  descargarPdf(id: number) {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Descargando...',
      timerProgressBar: true,showConfirmButton:false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.service.getNombreContenidoById(id).subscribe(response => {
          this.elemento.nombre = response.nombre.replace('.xml', '');
          this.elemento.contenido = response.contenido;
          this.service.descargaCfdiPdf(this.elemento).subscribe(response2 => {
            this.cerrarMensajeCarga();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(response2);
            a.download = response.nombre.replace('.xml', '');
            document.body.appendChild(a);
            a.click();
          }, err2 => {
            this.cerrarMensajeCarga();
            const fr = new FileReader();

            fr.onload = (e) => {
              console.log(JSON.parse('' + e.target.result))
            };
            fr.readAsText(err2.error);
            if (err2.error.mensaje == null || '' || undefined) {
              err2.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err2.error.mensaje
            });
          });
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });

  }
  catalogo() {
    this.busqueda_cfdi.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.service.catalogo(this.busqueda_cfdi).subscribe(
      response => {
        console.log(response);
        this.cfdis = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
        for (let x = 0; x < this.cfdis.length; x++) {
          this.cfdis[x].seleccionado = false;
          this.cfdis[x].estatus_verificado = 1;
        }
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  consultarListaNegra(rfc: string, indice: number) {
    if (this.consulta_lista_negra.lista.length === 0 ||
      (this.consulta_lista_negra.lista.length > 0
        && this.consulta_lista_negra.lista[0].rfc !== rfc)
    ) {
      Swal.fire({
        title: 'TNK Ledger',
        html: 'Verificando...',
        timerProgressBar: true,
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
          this.listaNegraService.consultarEstatusRfc(rfc).subscribe(
            response => {
              this.cerrarMensajeCarga();
              this.consulta_lista_negra = response.contenido;
              console.log(this.consulta_lista_negra);
              if (this.consulta_lista_negra.lista.length === 0) {
                this.cfdis[indice].estatus_verificado = 2;
                this.consulta_lista_negra = { campos: [], lista: [] };
              }
              if (this.consulta_lista_negra.lista.length > 0) {
                if (this.verificarSentenciaFavorable(this.consulta_lista_negra.lista) === false) {
                  this.cfdis[indice].estatus_verificado = 3;
                } else {
                  this.cfdis[indice].estatus_verificado = 2;
                  this.consulta_lista_negra = { campos: [], lista: [] };
                }
              }
            }, err => {
              this.cerrarMensajeCarga();
              if (err.error.mensaje == null || '' || undefined) {
                err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
              }
              Swal.fire({
                icon: 'error',
                title: 'TNK Ledger',
                text: err.error.mensaje
              });
            });
        }
      });

    }
  }
  verificarSentenciaFavorable(lista: any[]): boolean {
    for (let x = 0; x < lista.length; x++) {
      if (lista[x].situacion_del_contribuyente != 'Sentencia Favorable') {
        return false;
      }
    }
    return true;
  }
  cambiarPagina(event: any): void {
    this.busqueda_cfdi.pageNumber = event.page - 1;
    this.catalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda_cfdi.criteriaSearch[columnName] = find;
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  sortearPor(columnName: any): void {
    this.busqueda_cfdi.column = columnName;
    this.busqueda_cfdi.sort = true;
    this.busqueda_cfdi.pageNumber = 0;
    switch (this.busqueda_cfdi.order) {
      case 'desc':
        this.busqueda_cfdi.order = 'asc';
        break;
      default:
        this.busqueda_cfdi.order = 'desc';
        break;
    }
    this.catalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda_cfdi.itemsPerPage = 20;
    this.busqueda_cfdi.pageNumber = 0;
    if (this.busqueda_cfdi.criteriaSearch['fecha'] != null) {
      this.busqueda_cfdi.column = 'fecha';
      this.busqueda_cfdi.sort = true;
      this.busqueda_cfdi.pageNumber = 0;
      this.busqueda_cfdi.order = 'asc';
    }
    this.catalogo();
  }
  limpiarBusqueda(): void {
    setTimeout(() => {
      this.busqueda_cfdi.criteriaSearch = {};
      this.busqueda_cfdi.criteriaSearch['tipoCfdi'] = 0;
      this.buscarEnCatalogo();
    },
      50);
  }
  descargarXml(id: number): void {
    console.log(id);
  this.service.descargaXml(id).subscribe({
    next: (response: Blob) => {
      const fechaActual = new Date();
      const nombreArchivo = `Documentos_${fechaActual.getFullYear()}-${String(fechaActual.getMonth() + 1).padStart(2, '0')}-${String(fechaActual.getDate()).padStart(2, '0')}.zip`;

      const blobUrl = URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = nombreArchivo;
      a.click();

      URL.revokeObjectURL(blobUrl);
    },
    error: (err) => {
      const mensaje = err?.error?.mensaje || 'No hay documentos para exportar al xml';
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: mensaje
      });
      console.error(err);
    }
  });
}

  setPageModal(page: number) {
    this.page = page;
  }

  cargarSolicitudes(estatus: string) {
    if(estatus == 'p'){
      this.notificationService.showLoadingScreen('Espere mientras se verifica si sus solicitudes están disponibles para descargar...');
    }
    this.estatus_solicitud = estatus;
    this.solicitudes = [];
    this.satDescargaService.getByEmpIdAndEstatus(this.loginService.empresa, estatus,
      'na', 'na', 'na').subscribe(
        response => {
          this.cerrarMensajeCarga();
          this.solicitudes = response.contenido;
          console.log(this.solicitudes)
          this.totalPages = Math.ceil(this.solicitudes.length / this.itemsPerPage);
          if (response.mensaje != '') {
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: response.mensaje
            });
          }
        }, err => {
          $('#listaSolicitudesModal').modal('hide');
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        }
      );
  }




diferenciaDeDias(fecha1Str: string): number {
  // Fecha actual para fecha2Str 
  let fecha2Str =  new Date().toISOString().slice(0, 10);
  // Parsear fecha sin desfase (crear Date en zona local)
  function parseDateLocal(dateString: string): Date {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const fecha1 = parseDateLocal(fecha1Str);
  const fecha2 = parseDateLocal(fecha2Str);

  // Quitar milisegundos (por si acaso)
  fecha1.setMilliseconds(0);
  fecha2.setMilliseconds(0);

  const diferenciaEnMilisegundos = fecha2.getTime() - fecha1.getTime();
  const diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

  return diferenciaEnDias;
}
  descargarDocumentosSat(idSatDescargaId: number) {
    Swal.fire({
      title: 'TNK Ledger',
      text: `¿Está seguro de realizar la descarga?`,
      showCancelButton: true,
      confirmButtonText: 'Descargar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.mostrarMensajeDescarga();
        this.satDescargaService.descargarDocumentos(idSatDescargaId, this.loginService.usuario.id).subscribe(
          response => {
            this.cerrarMensajeCarga();
            Swal.fire({
              title: 'TNK Ledger',
              text: response.mensaje,
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: 'Ok'
            }).then((result1) => {
              if (result1.value) {
                this.cargarSolicitudes('d');
              }
            }
            );
          }, err => {
            this.cerrarMensajeCarga();
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
            console.log(err);
          }
        );
      }
    }
    );
  }

  descargarHistorico(id: number, nombre_archivo: string) {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Descargando...',
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.satDescargaService.descargaHistorico(id).subscribe(response => {
          this.cerrarMensajeCarga();
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = nombre_archivo;
          document.body.appendChild(a);
          a.click();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'El documento que intentas descargar no existe';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });

  }

  crearSolicitud() {
    this.generar_rango_mes();

    Swal.fire({
      title: "Puedes renovar la solicitud en caso de que el SAT esté demorando la respuesta",
      text: "¿Deseas generar una nueva solicitud?",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Crear Solicitud"
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        
        this.nuevaSolicitud.gral_emp_id = this.loginService.empresa as number;
        this.nuevaSolicitud.gral_usr_id_crea = this.loginService.usuario.id as number;
        this.satDescargaService.post(this.nuevaSolicitud).subscribe(
          response => {
            Swal.fire('TNK Ledger', response.mensaje, 'success');
            this.cargarSolicitudes('p');
          }, err => {
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
            console.log(err);
          }
        );


      }
    });



  }


   reenviarSolicitud(solicitud: any) {
    Swal.fire({
      title: "¿Desea renovar la solicitud?",
      text: "Se reiniciará la petición ante el SAT.",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Reenviar Solicitud"
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        
       solicitud.gral_emp_id = this.loginService.empresa as number;
        solicitud.gral_usr_id_crea = this.loginService.usuario.id as number;
        this.satDescargaService.post(solicitud).subscribe(
          response => {
            Swal.fire('TNK Ledger', response.mensaje, 'success');
            this.cargarSolicitudes('p');
          }, err => {
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
            console.log(err);
          }
        );


      }
    });



  }
  mostrarMensajeDescarga() {
    this.cargado = false;
    this.notificationService.showLoadingScreen('Descargando...');
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    this.notificationService.showLoadingScreen('Cargando...');
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    this.notificationService.closeLoadingScreen();
  }


  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }


    cargarAnos() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    
    this.periodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.nuevaSolicitud.anio = ejercicio ? ejercicio : 0;

    });

    this.periodoEjercicioService.periodo$.subscribe(periodo => {
      this.nuevaSolicitud.mes = periodo ? periodo : 12;
      if(this.nuevaSolicitud.mes == 13){
      this.nuevaSolicitud.mes = 12;
      }

    });
  }


  generar_rango_mes() {

    this.nuevaSolicitud.fecha_ini = this.formatDate(new Date(this.nuevaSolicitud.anio, this.nuevaSolicitud.mes - 1, 1));
    this.nuevaSolicitud.fecha_fin = this.formatDate(new Date(this.nuevaSolicitud.anio, this.nuevaSolicitud.mes, 0));
}
}

class Solicitud {
  tipo: String = 'e';
  mes: number = 1;
  anio: number = 2020;
  fecha_ini: String;
  fecha_fin: String;
  gral_emp_id: number;
  gral_usr_id_crea: number;
}